(() => {
  const splitTitle = document.getElementsByClassName('js-main-data-title');
  if (splitTitle) {
    for (let i = 0; i < splitTitle.length; i++) {
      const element = splitTitle[i];
      const tl = new TimelineMax();
      const mySplitText = new SplitText(element, {type: 'words,chars'});
      const chars = mySplitText.chars;
      TweenMax.set(element, {perspective: 1000});
      tl.staggerFrom(chars, 1, {opacity: 0, x: 100}, 0.2);
    }
  }

  const mainLogo = document.getElementsByClassName('js-main-logo');
  if (mainLogo) {
    for (let i = 0; i < mainLogo.length; i++) {
      const element = mainLogo[i];
      TweenMax.fromTo(element, 3, {y: -100, opacity: 0, delay: 0.5}, {y: 0, opacity: 1});
    }
  }

  const mapTooltip = document.getElementsByClassName('js-map-city');
  if (mapTooltip) {
    const tooltip = document.createElement('div');
    tooltip.classList.add('c-map__tooltip');
    document.body.appendChild(tooltip);

    for (let i = 0; i < mapTooltip.length; i++) {
      const item = mapTooltip[i];

      item.addEventListener('mousemove', function(e) {
        const sel = this;
        const title = sel.getAttribute('title');

        tooltip.style.display = 'block';
        tooltip.style.top = e.clientY + 'px';
        tooltip.style.left = e.clientX + 'px';
        tooltip.innerHTML = title;
      });

      // when mouse leave hide the tooltip
      item.addEventListener('mouseleave', function() {
        tooltip.style.display = 'none';
      });
    }
  }
})();
